import {FC} from "react";

const GoHighLevel: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 20,
  height = 20,
}) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path
      d="M4.9035 1.28711L0.990112 5.21018H3.76589V18.7129H6.08662V5.21018H8.81689L4.9035 1.28711Z"
      fill="#FBC530"
    />
    <path
      d="M3.76587 5.20996H6.0866V7.53643L3.76587 5.20996Z"
      fill="black"
      fillOpacity={0.18}
    />
    <path
      d="M15.0965 1.28711L11.1831 5.21018H13.9589V18.7129H16.2796V5.21018H19.0099L15.0965 1.28711Z"
      fill="#1CCE22"
    />
    <path
      d="M13.9589 5.20996H16.2796V7.53643L13.9589 5.20996Z"
      fill="black"
      fillOpacity={0.18}
    />
    <path
      d="M10 6.76074L6.08661 10.6838H8.63486V18.7124H11.3651V10.6838H13.9134L10 6.76074Z"
      fill="#3599FB"
    />
    <path
      d="M8.63489 10.6836H11.3652V13.4206L8.63489 10.6836Z"
      fill="black"
      fillOpacity={0.18}
    />
  </svg>
);
export default GoHighLevel;
